export const WIDGET_VIEW_TYPES = {
  COMPANIES_BODY: "companies-body",
  CLIENTS_BODY: "clients-body",
  CLIENT_BODY: "client-body",
};
